import { global } from "./_utils";
export const entries = global("entries");
